import { Box, Button, Wrap } from "@chakra-ui/react";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Href } from "../../components/Href";
import { PageLayout } from "../../components/PageLayout";
import { Splash } from "../../components/Splash";

export function Error500() {
  const intl = useIntl();

  const { reload } = useRouter();

  const breadcrumbItems = useMemo(() => {
    /** @type {import("../../components/Breadcrumb").BreadcrumbItem[]} */
    const items = [
      {
        title: intl.formatMessage({ defaultMessage: "Accueil" }),
        url: generateFrontPath({
          id: "@front.home",
        }),
      },
    ];
    return items;
  }, [intl]);

  const handleClickReload = useCallback(() => {
    reload();
  }, [reload]);

  return (
    <PageLayout
      breadcrumbItems={breadcrumbItems}
      title={intl.formatMessage({ defaultMessage: "Erreur interne" })}>
      <Box px="1rem" py="3rem">
        <Splash
          title={intl.formatMessage({ defaultMessage: "Erreur interne" })}
          description={intl.formatMessage(
            {
              defaultMessage:
                "Cette page est temporairement indisponible, merci de réessayer plus tard.",
            },
            {
              br: <br />,
            },
          )}
          src={generateFrontPath({
            id: "@front.internal-assets",
            parameters: { filePath: "illustrations/internal-error.svg" },
            includeBasePath: true,
          })}
          addon={
            <Wrap justify="center" spacing="1rem">
              <Href
                href={generateFrontPath({
                  id: "@front.home",
                })}>
                <Button variant="outline" colorScheme="brandPrimary">
                  <FormattedMessage defaultMessage="Retourner à l'accueil" />
                </Button>
              </Href>

              <Button
                onClick={handleClickReload}
                backgroundColor="brandPrimary.700"
                colorScheme="brandPrimary">
                <FormattedMessage defaultMessage="Recharger cette page" />
              </Button>
            </Wrap>
          }
        />
      </Box>
    </PageLayout>
  );
}
